import { Component, Input, OnChanges, SimpleChange, Output, EventEmitter, OnInit } from '@angular/core';
import { ForgotPasswordService } from '@shared/services';

@Component({
  selector: 'app-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss']
})
export class PasswordStrengthComponent implements OnInit, OnChanges {
  constructor(
    public forgotPwdService: ForgotPasswordService
  ) { }

  @Input() public passwordToCheck: string;
  @Output() passwordStrength = new EventEmitter<boolean>();
  @Output() passwordErrors = new EventEmitter<string[]>();

  passwordPolicies: PasswordPolicy[] = []

  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;
  msg = '';
  private errors = [] as string[];
  private colors = ['darkred', 'orangered', 'orange', 'yellowgreen'];

  ngOnInit() {
    this.forgotPwdService.getPwdPolicy().subscribe({
      next: (res) => {
        this.passwordPolicies = res.map(row => {
          let stringRegex = row.pwpRegex;
          var regexParts = /\/(.*)\/(.*)/.exec(stringRegex);
          return { ...row, pwpRegex: new RegExp(regexParts[1], regexParts[2]) }
        });
      }
    })
  }

  private checkStrength(password) {
    this.errors = [];

    this.passwordPolicies.forEach(pwp => {
      let test = pwp.pwpRegex.test(password);
      if (!test) {
        this.errors.push(pwp.pwpDtbshort);
      }
    })

    let fraction = (this.passwordPolicies.length / 4)
    let force = Math.floor((this.passwordPolicies.length - this.errors.length) / fraction) * 10;

    return force;
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    const password = changes.passwordToCheck.currentValue;
    this.setBarColors(4, '#DDD');
    if (password) {
      const pwdStrength = this.checkStrength(password);
      const c = this.getColor(pwdStrength);
      this.setBarColors(c.idx, c.col);

      pwdStrength === 40 ? this.passwordStrength.emit(true) : this.passwordStrength.emit(false);
      this.passwordErrors.emit(this.errors);

      switch (c.idx) {
        case 1:
          this.msg = 'pwd-strength-poor';
          break;
        case 2:
          this.msg = 'pwd-strength-not-good';
          break;
        case 3:
          this.msg = 'pwd-strength-average';
          break;
        case 4:
          this.msg = 'pwd-strength-good';
          break;
      }
    } else {
      this.msg = '';
    }
  }


  private getColor(s) {
    let idx = 0;
    if (s <= 10) {
      idx = 0;
    } else if (s <= 20) {
      idx = 1;
    } else if (s <= 30) {
      idx = 2;
    } else if (s <= 40) {
      idx = 3;
    } else {
      idx = 4;
    }
    return {
      idx: idx + 1,
      col: this.colors[idx]
    };
  }

  private setBarColors(count, col) {
    for (let n = 0; n < count; n++) {
      this['bar' + n] = col;
    }
  }

}

export interface PasswordPolicy {
  pwpId: number,
  pwpRegex: RegExp,
  pwpDtbshort: string
}
